<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card>
          <v-card-title style="word-break: break-word"> Confirm Registration
          </v-card-title>
          <v-img :src="require('../assets/photos/backgrounds/SAM_0042.jpg')" height="200px"></v-img>
          <v-card-subtitle>
            To complete the registration proess, please re-enter your email address and you will then be able to log
            in
          </v-card-subtitle>
          <v-text-field class="pl-2 pr-2 ml-2 mr-2" ref="emailField" v-model="email" label="Email address" outlined />
          <v-alert class="pl-4 pr-4 ml-4 mr-4" v-if="confirmRegistrationMessage" :type="confirmRegistrationStatus">
            {{ confirmRegistrationMessage }}
          </v-alert>
          <v-card-subtitle class="text-right">
            <v-btn class="ma-0 teal eps_white" outlined :loading="confirmProcessing" @click="confirmRegistration()">
              Confirm
              <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-send theme--light"
                style="font-size: 16px"></i>
            </v-btn>
          </v-card-subtitle>
          <v-card-subtitle>
            <p>We do this to reduce the likelihood of spammers and other unwanted accounts being created</p>
            <p>If you
              have any issues,
              please contact us using the 'Contact' page from the menu above</p>
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";

export default {
  name: "ConfirmRegistration",
  data: () => ({
    email: null,
    confirmRegistrationStatus: null, // or 'error'
    confirmRegistrationMessage: null,
    confirmProcessing: false,
  }),
  computed: {
    token() {
      return this.$route.params.token;
    }
  },
  methods: {
    async confirmRegistration() {

      this.confirmProcessing = true;

      let confirmRegistrationRequest = serverFunctions.getConfirmRegistrationRequest(this.email,
        this.token);
      let confirmRegistrationResponse = await serverFunctions.getRawPostResponse("/confirmRegistration", confirmRegistrationRequest);

      this.confirmProcessing = false;

      if (confirmRegistrationResponse.success) {
        this.$router.push("/login/registrationconfirmed")
      }
      else {
        this.confirmRegistrationStatus = "error";
        this.confirmRegistrationMessage = confirmRegistrationResponse.successMessage;
      }

    }
  }
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
